module.exports = __webpack_public_path__ + "img/racecourse-scottsville-turf-inner-2400.06b86812.svg";